
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landingPages/LocationInsightLandingPage",
      function () {
        return require("private-next-pages/landingPages/LocationInsightLandingPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landingPages/LocationInsightLandingPage"])
      });
    }
  